/* eslint-disable */
import { Marker } from "./Marker";
import { MarkerFullScreen } from "./MarkerFullScreen";

export class MarkerTable {
    constructor() {
        this._markers = [];
        this._markersFullScreen = [];
        for (let i = 0; i < 26; i++) {
            this._markers.push(new Marker({ imgPath: `static/${i}.jpg`, dataTarget: 'carousel', targetId: i }));
        }

        this._checkableVisible = false;
        this._checkableAllSelected = false;
    }

    switchCheckableVisible () {
        if (this._checkableVisible) {
            this._hideCheckables();
        } else {
            this._showCheckables();
        }
    }

    switchSelectAll () {
        if (this._checkableAllSelected) {
            this._unselectAllCheckables();
        } else {
            this._selectAllCheckables();
        }
    }

    selectedImagesURLS () {
        const imgs = [];

        if (!this._markers.some(marker => marker.selected)) {
            return imgs;
        }

        for (const { selected, imgForPrintURL } of this._markers) {
            if (selected) {
                imgs.push(imgForPrintURL);
            }
        }

        return imgs;
    }

    _showCheckables () {
        for (const mark of this._markers) {
            mark.show();
        }

        this._checkableVisible = true;
    }
    
    _hideCheckables () {
        for (const mark of this._markers) {
            mark.hide();
        }

        this._checkableVisible = false;
    }

    _selectAllCheckables () {
        for (const mark of this._markers) {
            mark.select();
        }

        this._checkableAllSelected = true;
    }
    
    _unselectAllCheckables () {
        for (const mark of this._markers) {
            mark.unSelect();
        }

        this._checkableAllSelected = false;
    }
}